import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/pages/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  /* {
     path: '/register',
     name: 'register',
     component: () => import('../views/pages/account/register'),
     meta: {
       beforeResolve(routeTo, routeFrom, next) {
         // If the user is already logged in
         if (store.getters['auth/loggedIn']) {
           // Redirect to the home page instead
           next({ name: 'home' })
         } else {
           // Continue to the login page
           next()
         }
       },
     },
   },*/
  /* {
     path: '/forgot-password',
     name: 'Forgot-password',
     component: () => import('../views/pages/account/forgot-password'),
     meta: {
       beforeResolve(routeTo, routeFrom, next) {
         // If the user is already logged in
         if (store.getters['auth/loggedIn']) {
           // Redirect to the home page instead
           next({ name: 'home' })
         } else {
           // Continue to the login page
           next()
         }
       },
     },
   },*/
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logout");
          store.dispatch("company/removeCompany");
        } else if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {
          store.dispatch("auth/logout");
          store.dispatch("company/removeCompany");
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: "home" } : { ...routeFrom });
      },
    },
  },
  {
    path: "/",
    name: "Inicio",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/dashboard/sales/index"),
  },
  //* *************** Users ************************** *//

  {
    path: "/forms/users",
    name: "users",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/Users/users"),
  },
  {
    path: "/forms/registro-rol",
    name: "registro-rol",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/Users/registro-rol"),
  },
  {
    path: "/forms/editar-rol/:id",
    name: "editar-rol",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/Users/editar-rol"),
  },
  {
    path: "/forms/permissions/:id",
    name: "permissions",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/Users/permissions"),
  },

  //* *************** Notifications ************************** *//

  {
    path: "/forms/notifications-list",
    name: "notifications-list",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/Notifications/notifications-list"),
  },

  //* *************** Mantenimiento ************************** *//

  {
    path: "/forms/maintenance",
    name: "maintenance",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/maintenance"),
  },

  //* ***************************************** *//

  {
    path: "/icons/feather",
    name: "feather",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/icons/feather"),
  },
  {
    path: "/icons/remix",
    name: "remix",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/icons/remix"),
  },
  {
    path: "/icons/boxicons",
    name: "boxicons",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/icons/boxicons"),
  },
  {
    path: "/icons/mdi",
    name: "mdi",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/icons/mdi"),
  },
  {
    path: "/icons/font-awesome",
    name: "font-awesome",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/icons/font-awesome"),
  },
  {
    path: "/icons/weather",
    name: "weather",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/icons/weather"),
  },

  {
    path: "/forms/validation",
    name: "validation",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/validation"),
  },

  //* *************** Registro de empresa ************************** *//

  {
    path: "/forms/editar-empresa/:id",
    name: "editar-empresa",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/editar-empresa"),
  },
  {
    path: "/forms/listado-empresa",
    name: "listado-empresa",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/listado-empresa"),
  },

  //* *************** Registro de empleados ************************** *//

  {
    path: "/forms/:id/registro-colaboradores",
    name: "registro-colaboradores",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/registro-empleados"),
  },
  {
    path: "/forms/editar-colaboradores/:id",
    name: "editar-colaboradores",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/editar-empleados"),
  },

  //* *************** Sedes ************************** *//

  {
    path: "/forms/:id/listado-sedes",
    name: "listado-sedes",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/listado-sucursales"),
  },

  {
    path: "/forms/:id/registro-sede",
    name: "registro-sede",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/registro-sucursal"),
  },
  {
    path: "/forms/editar-sede/:id",
    name: "editar-sede",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/editar-sucursal"),
  },

  //* *************** Registro de items ************************** *//

  {
    path: "/forms/estandares",
    name: "estandares",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/estandares"),
  },
  {
    path: "/forms/registro-item",
    name: "registro-item",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/registro-item"),
  },
  {
    path: "/forms/editar-item/:id",
    name: "editar-item",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/editar-item"),
  },

  //* *************** Responsable SG ************************** *//

  {
    path: "/forms/:id/responsable-sg",
    name: "responsable-sg",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/responsable-sg"),
  },
  {
    path: "/forms/responsable-sg/add",
    name: "responsable-sg-add",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/responsable-sg-registrar"),
  },
  {
    path: "/forms/responsable-sg/:id",
    name: "responsable-sg-view",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/responsable-sg-editar"),
  },

  //* *************** Asignación de recursos SG-SST ************************** *//

  {
    path: "/forms/estandares/recursos-sgsst",
    name: "recursos-sgsst",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/recursos-sgsst"),
  },

  {
    path: "/forms/estandares/recursos-sgsst/:id",
    name: "recursos-sgsst-edit",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/recursos-sgsst-editar"),
  },

  //* *************** 1.1.6 Copasst ************************** *//

  {
    path: "/forms/estandares/:id/acta-conformacion1.1.6",
    name: "acta-conformacion1.1.6",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/Copasst/acta-conformacion1.1.6"),
  },
  // Informe trimestral de gestión del COPASST / Vigía de SST para la gerencia (SST-FT-033).
  {
    path: "/forms/estandares/:id/informe-trimestral-copasst",
    name: "informe-trimestral-copasst",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/Copasst/informe-trimestral-copasst"),
  },
  {
    path: "/forms/estandares/informe-trimestral-copasst-editar/:reportId?",
    name: "informe-trimestral-copasst-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/Copasst/informe-trimestral-copasst-editar"),
  },
  {
    path: "/forms/estandares/:id/acta-conformacion1.1.6/:copasst",
    name: "acta-conformacion1.1.6-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/Copasst/copasst-menor-editar"),
  },
  {
    path: "/forms/estandares/:id/capacitacion-1.1.7",
    name: "acta-capacitacion",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/CapacitacionCopasst/CapacitacionCopasst"),
  },
  {
    path: "/forms/estandares/:id/acta-reunion",
    name: "acta-reunion",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/acta-reunion"),
  },
  {
    path: "/forms/estandares/:id/capacitacion-copasst/:copasst",
    name: "capacitacion-coppast",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/capacitacion-coppast"),
  },
  {
    path: "/forms/estandares/:id/acta-copasst/:copasst",
    name: "acta-copasst-mayor",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/Copasst/ActaCopasst"),
  },
  {
    path: "/forms/estandares/:id/listado-actas",
    name: "listado-actas",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/listado-actas"),
  },

  {
    path: "/forms/estandares/:id/seguimiento-copasst",
    name: "seguimiento-copasst",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/Copasst/Followup/ListadoSeguimiento"),
  },

  //* *************** 1.1.8 Comité convivencia ************************** *//

  {
    path: "/forms/estandares/:id/conformacion-comite-convivencia",
    name: "conformacion-comite-convivencia",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/conformacion-comite-convivencia"),
  },
  {
    path: "/forms/estandares/:id/comite-convivencia/:comite",
    name: "comite-convivencia",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/Committee/Comite"),
  },
  {
    path: "/forms/estandares/:id/seguimiento-comite",
    name: "seguimiento-comite",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/Committee/Followup/ListadoSeguimiento"),
  },
  {
    path: "/forms/estandares/:id/acta-seguimiento-comite/:meeting",
    name: "acta-seguimiento-comite",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/Committee/Followup/ActaSeguimiento"),
  },
  {
    path: "/forms/estandares/:id/informe-trimestral-convivencia",
    name: "informe-trimestral-convivencia",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/informe-trimestral-convivencia"),
  },
  {
    path: "/forms/estandares/informe-trimestral-convivencia-editar/:reportId?",
    name: "informe-trimestral-convivencia-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/informe-trimestral-convivencia-editar"),
  },

  //* *************** 1.2.1 Programa Capacitación Promoción y Prevención - P y P  ************************** *//

  {
    path: "/forms/estandares/:id/promocion-prevencion",
    name: "promocion-prevencion",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/promocion-prevencion"),
  },
  {
    path: "/forms/estandares/:id/promocion-prevencion/:promotion",
    name: "promocion-prevencion",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/promocion-prevencion-editar"),
  },

  {
    path: "/forms/estandares/:id/promocion-prevencion-ver/:promotion",
    name: "promocion-prevencion-ver",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/promocion-prevencion-ver"),
  },
  {
    path: "/forms/estandares/:id/asistencia-capacitacion/:trainingId",
    name: "asistencia-capacitacion",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/asistencia-capacitacion"),
  },
  {
    path: "/forms/estandares/:id/cobertura-capacitaciones",
    name: "cobertura-capacitaciones",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/cobertura-capacitaciones"),
  },

  //* *************** 3.1.2 Actividades de Promoción y Prevención en Salud  ************************** *//

  {
    path: "/forms/estandares/:id/actividades-promocion",
    name: "actividades-promocion",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/PromotionActivities/PromotionActivities"),
  },
  {
    path: "/forms/estandares/actividades-promocion/:promotion",
    name: "actividades-promocion",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/forms/PromotionActivities/PromotionActivitiesEdit"
      ),
  },
  {
    path: "/forms/estandares/actividades-promocion-evidencia/:promotion",
    name: "actividades-promocion-evidencia",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/forms/PromotionActivities/PromotionActivitiesEvidencia"
      ),
  },

    //* *************** 3.1.3 Perfiles de cargo - profesiograma   ************************** *//

    {
      path: "/forms/estandares/:id/perfiles-cargo",
      name: "perfiles-cargo",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/perfiles-cargo"),
    },
    {
      path: "/forms/estandares/perfiles-cargo-editar/:id",
      name: "perfiles-cargo-editar",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/perfiles-cargo-editar"),
    },
    {
      path: "/forms/estandares/perfiles-cargo-ver/:id",
      name: "perfiles-cargo-ver",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/perfiles-cargo-ver"),
    },
    {
      path: "/forms/estandares/:id/evidencia-profesiograma",
      name: "evidencia-profesiograma",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/evidencia-profesiograma"),
    },

    {
      path: "/forms/estandares/evidencia-profesiograma-editar/:id",
      name: "evidencia-profesiograma-editar",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/evidencia-profesiograma-editar"),
    },

    {
      path: "/forms/estandares/evidencia-profesiograma-ver/:id",
      name: "evidencia-profesiograma-ver",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/evidencia-profesiograma-ver"),
    },


      //* *************** 3.1.5 Custodia de Historias Clínicas Ocupacionales ************************** *//

      {
        path: "/forms/estandares/:id/custodia-historias",
        name: "custodia-historias",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/custodia-historias"),
      },
  
  
      {
        path: "/forms/estandares/custodia-historias-editar/:id",
        name: "custodia-historias-editar",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/custodia-historias-editar"),
      },  

      {
        path: "/forms/estandares/custodia-historias-ver/:id",
        name: "custodia-historias-ver",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/custodia-historias-ver"),
      },  

  //* *************** 3.1.7 Estilo de vida y entornos saludables (Controles tabaquismo, alcoholismo, fármaco dependencia y otros) ************************** *//

  {
    path: "/forms/estandares/:id/estilo-vida",
    name: "estilo-vida",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/estilo-vida"),
  },
  {
    path: "/forms/estandares/estilo-vida-editar/:id",
    name: "estilo-vida-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/estilo-vida-editar"),
  },

  {
    path: "/forms/estandares/estilo-vida-evidencia/:id",
    name: "estilo-vida-evidencia",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/estilo-vida-evidencia"),
  },

  {
    path: "/forms/estandares/:id/politica-alcohol-drogas",
    name: "politica-alcohol-drogas",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/politica-alcohol-drogas"),
  },

  {
    path: "/forms/estandares/politica-alcohol-drogas-editar/:id",
    name: "politica-alcohol-drogas-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/politica-alcohol-drogas-editar"),
  },

  {
    path: "/forms/estandares/eliminacion-residuos-ver/:id",
    name: "eliminacion-residuos-ver",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/eliminacion-residuos-ver"),
  },

    //* *************** 3.1.8 Servicios de higiene ************************** *//

    {
      path: "/forms/estandares/:id/servicios-higiene",
      name: "servicios-higiene",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/servicios-higiene"),
    },


    {
      path: "/forms/estandares/servicios-higiene-editar/:id",
      name: "servicios-higiene-editar",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/servicios-higiene-editar"),
    },

    {
      path: "/forms/estandares/servicios-higiene-ver/:id",
      name: "servicios-higiene-ver",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/servicios-higiene-ver"),
    },

/*     {
      path: "/forms/estandares/servicios-higiene-editar/:id",
      name: "servicios-higiene-editar",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/servicios-higiene-editar"),
    }, */
  
    {
      path: "/forms/estandares/eliminacion-residuos-ver/:id",
      name: "eliminacion-residuos-ver",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/eliminacion-residuos-ver"),
    },

  //* *************** 3.1.9 Eliminación adecuada de residuos sólidos, líquidos o gaseosos ************************** *//

  {
    path: "/forms/estandares/:id/eliminacion-residuos",
    name: "eliminacion-residuos",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/eliminacion-residuos"),
  },
  {
    path: "/forms/estandares/eliminacion-residuos-editar/:id",
    name: "eliminacion-residuos-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/eliminacion-residuos-editar"),
  },

  {
    path: "/forms/estandares/eliminacion-residuos-ver/:id",
    name: "eliminacion-residuos-ver",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/eliminacion-residuos-ver"),
  },

    //* *************** 3.3.1  Medición de la severidad de los Accidentes de Trabajo ************************** *//

    {
      path: "/forms/estandares/:id/medicion-severidad",
      name: "medicion-severidad",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/medicion-severidad"),
    },
  
    {
      path: "/forms/estandares/medicion-severidad-editar/:id",
      name: "medicion-severidad-editar",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/medicion-severidad-editar"),
    },
  
    {
      path: "/forms/estandares/medicion-severidad-ver/:id",
      name: "medicion-severidad-ver",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/medicion-severidad-ver"),
    },
  
    {
      path: "/forms/estandares/:id/medicion-severidad-grafica",
      name: "medicion-severidad-grafica",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/medicion-severidad-grafica"),
    },

  //* *************** 3.3.2 Reporte de los Accidentes de Trabajo y enfermedad Laboral ************************** *//

  {
    path: "/forms/estandares/:id/medicion-frecuencia",
    name: "medicion-frecuencia",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/medicion-frecuencia"),
  },

  {
    path: "/forms/estandares/medicion-frecuencia-editar/:id",
    name: "medicion-frecuencia-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/medicion-frecuencia-editar"),
  },

  {
    path: "/forms/estandares/medicion-frecuencia-ver/:id",
    name: "medicion-frecuencia-ver",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/medicion-frecuencia-ver"),
  },

  {
    path: "/forms/estandares/:id/medicion-frecuencia-grafica",
    name: "medicion-frecuencia-grafica",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/medicion-frecuencia-grafica"),
  },

    //* *************** 3.3.3 Medición de la Mortalidad de los AT ************************** *//

    {
      path: "/forms/estandares/:id/medicion-mortalidad",
      name: "medicion-mortalidad",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/medicion-mortalidad"),
    },
  
    {
      path: "/forms/estandares/medicion-mortalidad-editar/:id",
      name: "medicion-mortalidad-editar",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/medicion-mortalidad-editar"),
    },
  
    {
      path: "/forms/estandares/medicion-mortalidad-ver/:id",
      name: "medicion-mortalidad-ver",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/medicion-mortalidad-ver"),
    },
  
    {
      path: "/forms/estandares/:id/medicion-mortalidad-grafica",
      name: "medicion-mortalidad-grafica",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/medicion-mortalidad-grafica"),
    },

    //* *************** 3.3.4 Medición de la prevalencia de los incidentes, Accidentes de Trabajo y Enfermedad Laboral ************************** *//

    {
      path: "/forms/estandares/:id/medicion-prevalencia",
      name: "medicion-prevalencia",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/medicion-prevalencia"),
    },
  
    {
      path: "/forms/estandares/medicion-prevalencia-editar/:id",
      name: "medicion-prevalencia-editar",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/medicion-prevalencia-editar"),
    },
  
    {
      path: "/forms/estandares/medicion-prevalencia-ver/:id",
      name: "medicion-prevalencia-ver",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/medicion-prevalencia-ver"),
    },
  
    {
      path: "/forms/estandares/:id/medicion-prevalencia-grafica",
      name: "medicion-prevalencia-grafica",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/medicion-prevalencia-grafica"),
    },

        //* *************** 3.3.5 Medición de la incidencia de la Enfermedad Laboral ************************** *//

        {
          path: "/forms/estandares/:id/medicion-incidencia",
          name: "medicion-incidencia",
          meta: {
            authRequired: true,
          },
          component: () =>
            import("../views/pages/forms/medicion-incidencia"),
        },
      
        {
          path: "/forms/estandares/medicion-incidencia-editar/:id",
          name: "medicion-incidencia-editar",
          meta: {
            authRequired: true,
          },
          component: () =>
            import("../views/pages/forms/medicion-incidencia-editar"),
        },

        {
          path: "/forms/estandares/medicion-incidencia-ver/:id",
          name: "medicion-incidencia-ver",
          meta: {
            authRequired: true,
          },
          component: () =>
            import("../views/pages/forms/medicion-incidencia-ver"),
        },
      
        {
          path: "/forms/estandares/medicion-frecuencia-ver/:id",
          name: "medicion-frecuencia-ver",
          meta: {
            authRequired: true,
          },
          component: () =>
            import("../views/pages/forms/medicion-frecuencia-ver"),
        },
      
        {
          path: "/forms/estandares/:id/medicion-incidencia-grafica",
          name: "medicion-incidencia-grafica",
          meta: {
            authRequired: true,
          },
          component: () =>
            import("../views/pages/forms/medicion-incidencia-grafica"),
        },


  //* *************** 3.3.6 Medición del ausentismo por causa médica ************************** *//

  {
    path: "/forms/estandares/:id/medicion-ausentismo",
    name: "medicion-ausentismo",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/medicion-ausentismo"),
  },

  {
    path: "/forms/estandares/:id/dias-laborales",
    name: "dias-laborales",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/dias-laborales"),
  },

  {
    path: "/forms/estandares/dias-laborales-editar/:id",
    name: "dias-laborales-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/dias-laborales-editar"),
  },
  {
    path: "/forms/estandares/dias-laborales-ver/:id",
    name: "dias-laborales-ver",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/dias-laborales-ver"),
  },

  {
    path: "/forms/estandares/:id/medicion-ausentismo-grafica",
    name: "medicion-ausentismo-grafica",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/medicion-ausentismo-grafica"),
  },

  {
    path: "/forms/estandares/:id/medicion-ausentismo-registro",
    name: "medicion-ausentismo-registro",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/medicion-ausentismo-registro"),
  },

  {
    path: "/forms/estandares/:id/medicion-ausentismo-otras",
    name: "medicion-ausentismo-otras",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/medicion-ausentismo-otras"),
  },

  {
    path: "/forms/estandares/medicion-ausentismo-editar/:id",
    name: "medicion-ausentismo-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/medicion-ausentismo-editar"),
  },

  {
    path: "/forms/estandares/medicion-ficha-ver/:id",
    name: "medicion-ficha-ver",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/medicion-ficha-ver"),
  },

  {
    path: "/forms/estandares/medicion-ausentismo-ver/:id",
    name: "medicion-ausentismo-ver",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/medicion-ausentismo-ver"),
  },

  //* *************** 1.2.2 Capacitación, Inducción y Reinducción en SG SST   ************************** *//

  {
    path: "/forms/estandares/:id/induccion",
    name: "induccion-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/capacitacion-induccion"),
  },

  {
    path: "/forms/estandares/:id/induccion/:induction",
    name: "induccion",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/capacitacion-induccion-editar"),
  },

  {
    path: "/forms/estandares/:id/acta-intervencion",
    name: "acta-intervencion-nueva",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/acta-intervencion-editar"),
  },

  {
    path: "/forms/estandares/:id/acta-intervencion/:acta",
    name: "acta-intervencion-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/acta-intervencion-editar"),
  },

  {
    path: "/forms/estandares/:id/induccion-ver/:induction",
    name: "induccion",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/capacitacion-induccion-ver"),
  },

  //* *************** Medicina ocupacional ítem 3.1.1 ************************** *//

  {
    path: "/forms/estandares/:id/perfil-sociodemografico",
    name: "perfil-sociodemografico",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/perfil-sociodemografico"),
  },

  {
    path: "/forms/estandares/:id/perfil-sociodemografico-grafica",
    name: "perfil-sociodemografico-grafica",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/perfil-sociodemografico-grafica"),
  },

  {
    path: "/forms/estandares/perfil-sociodemografico-editar/:id",
    name: "perfil-sociodemografico-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/perfil-sociodemografico-editar"),
  },
  
/**3.1.4 */
  {
    path: "/forms/estandares/:id/nueva-medicina-ocupacional",
    name: "nueva-medicina-ocupacional",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/nueva-medicina-ocupacional"),
  },
/**2.1.1 */
  {
    path: "/forms/estandares/:id/sgsst-policies",
    name: "politicas-sgsst",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/sgsst-policies"),
  },
  /**2.4.1 */
  {
    path: "/forms/estandares/:id/indentification-plan",
    name: "plan-identificacion",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/plan-objetivos"),
  },
  {
    path: "/forms/estandares/:companyId/identification-plan-editar/:id",
    name: "plan-objetivos-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/plan-objetivos-editar"),
  },
  {
    path: "/forms/estandares/:companyId/plan-trabajo",
    name: "plan-trabajo-nuevo",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/plan-trabajo-editar"),
  },
  {
    path: "/forms/estandares/:companyId/plan-trabajo/:plan",
    name: "plan-trabajo-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/plan-trabajo-editar"),
  },
  /* {
     path: '/forms/estandares/:id/indentification-plan',
     name: 'plan-identificacion',
     meta: {
       authRequired: true,
     },
     component: () => import('../views/pages/forms/plan-identificar')
   },*/
   /**4.2.1 */
  {
    path: "/forms/estandares/:id/preventive-measures",
    name: "medidas-preventivas",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/medidas-preventivas"),
  },
  {
    path: "/forms/estandares/:id/preventive-measures/:preventive",
    name: "medidas-preventivas-old",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/medidas-preventivas-editar"),
  },
  {
    path: "/forms/estandares/:companyId/medidas-prevencion",
    name: "medidas-prevencion-nueva",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/medidas-preventivas-editar"),
  },
  {
    path: "/forms/estandares/:companyId/medidas-prevencion/:matrix",
    name: "medidas-prevencion-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/medidas-preventivas-editar"),
  },
  {
    path: "/forms/estandares/:id/medicina-ocupacional",
    name: "medicina-ocupacional",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/medicina-ocupacional"),
  },

  {
    path: "/forms/estandares/:id/medicina-ocupacional-comunicacion",
    name: "medicina-ocupacional",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/medicina-ocupacional-comunicacion"),
  },

  {
    path: "/forms/estandares/:companies_id/medicina-ocupacional-editar/:id",
    name: "medicina-ocupacional-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/medicina-ocupacional-editar"),
  },

  {
    path: "/forms/estandares/medicina-ocupacional-empleados/:id",
    name: "medicina-ocupacional-empleados",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/medicina-ocupacional2"),
  },
  {
    path: "/forms/estandares/:employee_id/medicina-ocupacional-danger/:id",
    name: "medicina-ocupacional-danger",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/medicina-ocupacional-danger"),
  },
  {
    path: "/forms/estandares/medicina-ocupacional-danger-editar/:id",
    name: "medicina-ocupacional-danger-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/medicina-ocupacional-dangerEditar"),
  },
  //* *************** Reporte accidentes 3.2.2 ************************** *//
  {
    path: "/forms/estandares/:idCompany/investigacion-crear/:id",
    name: "investigacion-crear",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/investigacion-crear"),
  },

  {
    path: "/forms/estandares/:idCompany/investigacion-editar/:id",
    name: "investigacion-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/investigacion-editar"),
  },
  {
    path: "/forms/estandares/:id/investigacion",
    name: "investigacion",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/investigacion"),
  },
  {
    path: "/forms/estandares/:id/prueba",
    name: "prueba",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/prueba"),
  },
  /**3.2.1 */
  {
    path: "/forms/estandares/:id/reporte-accidentes",
    name: "reporte-accidentes",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/reporte-accidentes"),
  },
  {
    path: "/forms/estandares/:id/reporte-no-accidentes",
    name: "reporte-no-accidentes",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/reporte-no-accidentes"),
  },
  {
    path: "/forms/estandares/:idCompany/reporte-accidentes-editar/:id",
    name: "reporte-accidentes-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/reporte-accidentes-editar"),
  },
  //* *************** Identificación de peligros ítem 4.1.2 ************************** *//
  {
    path: "/forms/estandares/:id/identificacion-peligros",
    name: "identificacion-peligros",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/identificacion-peligros"),
  },
  {
    path: "/forms/estandares/identificacion-peligros-editar/:id",
    name: "identificacion-peligros-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/identificacion-peligros-editar"),
  },
  {
    path: "/forms/estandares/:companyId/matriz-riesgos",
    name: "matriz-riesgos-nueva",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/matriz-riesgos-editar"),
  },
  {
    path: "/forms/estandares/:companyId/matriz-riesgos/:matrix",
    name: "matriz-riesgos-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/matriz-riesgos-editar"),
  },

    //* *************** 4.1.3 Identificación de sustancias catalogadas como carcinógenas o con toxicidad aguda  ************************** *//
    {
      path: "/forms/estandares/:id/identificacion-sustancias",
      name: "identificacion-sustancias",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/identificacion-sustancias"),
    },
    {
      path: "/forms/estandares/:companyId/matriz-sustancias",
      name: "matriz-sustancias-nueva",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/matriz-sustancias-editar"),
    },
    {
      path: "/forms/estandares/:companyId/matriz-sustancias/:matrix",
      name: "matriz-sustancias-editar",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/matriz-sustancias-editar"),
    },
    {
      path: "/forms/estandares/identificacion-sustancias-editar/:id",
      name: "identificacion-sustancias-editar",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/identificacion-sustancias-editar"),
    },

    {
      path: "/forms/estandares/identificacion-sustancias-ver/:id",
      name: "identificacion-sustancias-ver",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/identificacion-sustancias-ver"),
    },

    {
      path: "/forms/estandares/hojas-seguridad/:id",
      name: "hojas-seguridad",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/hojas-seguridad"),
    },
    {
      path: "/forms/estandares/hojas-seguridad-editar/:id",
      name: "hojas-seguridad-editar",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/hojas-seguridad-editar"),
    },

  //* *************** Metodología para la identificación ítem 4.1.1 ************************** *//
  {
    path: "/forms/estandares/metodologia-identificacion",
    name: "metodologia-identificacion",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/metodologia-identificacion"),
  },

    //* *************** 4.1.4 Realización mediciones ambientales, químicos, físicos y biológicos ************************** *//
    {
      path: "/forms/estandares/:id/realizar-mediciones",
      name: "realizar-mediciones",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/realizar-mediciones"),
    },
    {
      path: "/forms/estandares/realizar-mediciones-editar/:id",
      name: "realizar-mediciones-editar",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/realizar-mediciones-editar"),
    },
    {
      path: "/forms/estandares/realizar-mediciones-ver/:id",
      name: "realizar-mediciones-ver",
      meta: {
        authRequired: true,
      },
      component: () =>
        import("../views/pages/forms/realizar-mediciones-ver"),
    },

  //* *************** ítem 4.2.2 ************************** *//
  {
    path: "/forms/estandares/:id/verificacion-medidas",
    name: "verificacion-medidas",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/medidas-prevencion-control"),
  },

    //* *************** 4.2.3 Procedimientos, instructivos, fichas, protocolos  ************************** *//
    {
      path: "/forms/estandares/:id/procedimientos",
      name: "procedimientos",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/procedimientos"),
    },

    {
      path: "/forms/estandares/procedimientos-evidencia/:id",
      name: "procedimientos-evidencia",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/procedimientos-evidencia"),
    },

    {
      path: "/forms/estandares/procedimientos-evidencia-editar/:id",
      name: "procedimientos-evidencia-editar",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/procedimientos-evidencia-editar"),
    },

    {
      path: "/forms/estandares/procedimientos-evidencia-ver/:id",
      name: "procedimientos-evidencia-ver",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/procedimientos-evidencia-ver"),
    },

      //* *************** 4.2.4 Inspecciones de seguridad ************************** *//


      {
        path: "/forms/estandares/:id/inspecciones-seguridad",
        name: "inspecciones-seguridad",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/inspecciones-seguridad"),
      },

      {
        path: "/forms/estandares/inspecciones-seguridad-editar/:id",
        name: "inspecciones-seguridad-editar",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/inspecciones-seguridad-editar"),
      },

      
      {
        path: "/forms/estandares/evidencia-inspeccion/:id",
        name: "evidencia-inspeccion",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/evidencia-inspeccion"),
      },

      {
        path: "/forms/estandares/evidencia-inspeccion-editar/:id",
        name: "evidencia-inspeccion-editar",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/evidencia-inspeccion-editar"),
      },


  //* ***************Base de conocimiento ************************** *//
  {
    path: "/forms/general",
    name: "general",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/BaseConocimiento/general"),
  },
  {
    path: "/forms/copasst",
    name: "copasst",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/BaseConocimiento/copasst"),
  },
  {
    path: "/forms/accidentes",
    name: "accidentes",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/BaseConocimiento/accidentes"),
  },
  {
    path: "/forms/medicina",
    name: "medicina",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/BaseConocimiento/medicina-ocupacional"),
  },
  {
    path: "/forms/capacitacion",
    name: "capacitacion",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/BaseConocimiento/capacitacion"),
  },
  {
    path: "/forms/prevencion",
    name: "prevencion",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/BaseConocimiento/prevencion"),
  },
  {
    path: "/forms/elemento",
    name: "elemento",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/BaseConocimiento/elemento"),
  },
  {
    path: "/forms/peligros",
    name: "peligros",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/BaseConocimiento/peligros"),
  },

  {
    path: "/forms/curso",
    name: "curso",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/BaseConocimiento/curso50"),
  },

  {
    path: "/forms/convivencia",
    name: "convivencia",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/BaseConocimiento/convivencia"),
  },

  {
    path: "/forms/actividades-medicina",
    name: "actividades-medicina",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/BaseConocimiento/actividades-medicina"),
  },
  {
    path: "/forms/sg-sst",
    name: "sg-sst",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/BaseConocimiento/sg-sst"),
  },
  {
    path: "/forms/matriz",
    name: "matriz",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/BaseConocimiento/matriz"),
  },

  {
    path: "/forms/sustancias-quimicas",
    name: "sustancias-quimicas",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/BaseConocimiento/sustancias-quimicas"),
  },

  {
    path: "/forms/procedimiento-auditoria",
    name: "procedimiento-auditoria",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/BaseConocimiento/procedimiento-auditoria"),
  },

  {
    path: "/forms/mecanismo-comunicacion",
    name: "procedimiento-auditoria",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/BaseConocimiento/mecanismo-comunicacion"),
  },

  {
    path: "/forms/especificaciones-sst-adquisiciones",
    name: "especificaciones-sst-adquisiciones",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/BaseConocimiento/especificaciones-sst-adquisiciones"),
  },

  {
    path: "/forms/procedimiento-acciones-correctivas",
    name: "procedimiento-acciones-correctivas",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/BaseConocimiento/procedimiento-acciones-correctivas"),
  },

  //* ***************************************** *//

  {
    path: "/forms/estandares/:id/capacitacion-prevencion",
    name: "capacitacion-coppast1.2.1",
    meta: {
      authRequired: true,
    },
    component: () =>
      import(
        "../views/pages/forms/PromotionPrevention/capacitacion-coppast1.2.1"
      ),
  },

  //* ***************4.2.5************************** *//

  {
    path: "/forms/estandares/mantenimiento-periodico/:id",
    name: "mantenimiento-periodico",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/mantenimiento-periodico-instalaciones"),
  },
  {
    path: "/forms/estandares/:id/administracion-equipos",
    name: "administracion-equipos",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/administracion-equipos"),
  },

  //* *************** 3.1.6 Restricciones y recomendaciones laborales  ************************** *//

  {
    path: "/forms/estandares/:id/restricciones-colaboraciones",
    name: "restricciones-colaboraciones",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/restricciones-colaboraciones"),
  },

  {
    path: "/forms/estandares/:id/restricciones-colaboraciones-agregar",
    name: "restricciones-colaboraciones-agregar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/restricciones-colaboraciones-agregar"),
  },

  {
    path: "/forms/estandares/restricciones-recomendaciones-editar/:id",
    name: "restricciones-recomendaciones-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/restricciones-recomendaciones-editar"),
  },

  {
    path: "/forms/estandares/:id/restricciones-colaboraciones-seguimientos/:id",
    name: "restricciones-colaboraciones-seguimientos",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/restricciones-colaboraciones-seguimientos"),
  },

  {
    path: "/forms/estandares/:id/restricciones-colaboraciones-editar/:id",
    name: "restricciones-colaboraciones-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/restricciones-colaboraciones-editar"),
  },

  //* ***************5.1.2************************** *//
  {
    // listo
    path: "/forms/estandares/brigada-prevencion-registro/:id",
    name: "brigada-prevencion-registro",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/brigada-prevencion-registro"),
  },
  {
    // listo
    path: "/forms/estandares/brigada-prevencion-editar/:id",
    name: "brigada-prevencion-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/brigada-prevencion-editar"),
  },
  {
    // subidos de videos
    path: "/forms/estandares/brigada-prevencion-capacitacion",
    name: "brigada-prevencion-capacitacion",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/brigada-prevencion-capacitacion"),
  },
  {
    path: "/forms/estandares/ver-capacitaciones",
    name: "ver-capacitaciones",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/ver-capacitaciones"),
  },
  {
    path: "/forms/estandares/brigada-prevencion-capacitacion-editar/:id",
    name: "brigada-prevencion-capacitacion-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/brigada-prevencion-capacitacion-editar"),
  },
  {
    path: "/forms/estandares/brigada-prevencion-capacitacion-ver/:id",
    name: "brigada-prevencion-capacitacion-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/brigada-prevencion-capacitacion-ver"),
  },
  {
    //
    path: "/forms/estandares/brigada-evidencia/:id",
    name: "brigada",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/brigada-prevencion"),
  },
  {
    //
    path: "/forms/estandares/brigada-evidencia-editar/:id",
    name: "brigada",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/brigada-prevencion-evidencia-editar"),
  },

      //* *************** 6.1.1 Indicadores de Estructura, Proceso y Resultado ************************** *//

      {
        path: "/forms/estandares/:id/indicadores",
        name: "indicadores",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/indicadores"),
      },
      {
        path: "/forms/estandares/indicadores-editar/:id",
        name: "indicadores-editar",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/indicadores-editar"),
      },
      {
        path: "/forms/estandares/indicadores-ver/:id",
        name: "indicadores-ver",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/indicadores-ver"),
      },
      {
        path: "/forms/estandares/:id/evaluacion-indicadores",
        name: "evaluacion-indicadores",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/evaluacion-indicadores"),
      },
      {
        path: "/forms/estandares/:id/evaluacion-indicadores-consolidado",
        name: "evaluacion-indicadores-consolidado",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/evaluacion-indicadores-consolidado"),
      },
      {
        path: "/forms/estandares/:id/evaluacion-indicadores-estructura",
        name: "evaluacion-indicadores-estructura",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/evaluacion-indicadores-estructura"),
      },
      {
        path: "/forms/estandares/evaluacion-indicadores-estructura-ver/:id",
        name: "evaluacion-indicadores-estructura-ver",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/evaluacion-indicadores-estructura-ver"),
      },
      {
        path: "/forms/estandares/:id/evaluacion-indicadores-proceso",
        name: "evaluacion-indicadores-proceso",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/evaluacion-indicadores-proceso"),
      },
      {
        path: "/forms/estandares/evaluacion-indicadores-proceso-ver/:id",
        name: "evaluacion-indicadores-proceso-ver",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/evaluacion-indicadores-proceso-ver"),
      },
      {
        path: "/forms/estandares/:id/evaluacion-indicadores-resultado",
        name: "evaluacion-indicadores-resultado",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/evaluacion-indicadores-resultado"),
      },
      {
        path: "/forms/estandares/evaluacion-indicadores-resultado-ver/:id",
        name: "evaluacion-indicadores-resultado-ver",
        meta: {
          authRequired: true,
        },
        component: () => import("../views/pages/forms/evaluacion-indicadores-resultado-ver"),
      },
  
    //* *************** 6.1.2 La Empresa realiza auditoría por lo menos una vez al año  ************************** *//

    {
      path: "/forms/estandares/:id/auditoria",
      name: "auditoria",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/auditoria"),
    },

    
    {
      path: "/forms/estandares/auditoria-editar/:id",
      name: "auditoria-editar",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/auditoria-editar"),
    },

    {
      path: "/forms/estandares/auditoria-plan/:id",
      name: "auditoria-plan",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/auditoria-plan"),
    },

    {
      path: "/forms/estandares/auditoria-plan-editar/:id",
      name: "auditoria-plan-editar",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/auditoria-plan-editar"),
    },

    {
      path: "/forms/estandares/auditoria-plan-ver/:id",
      name: "auditoria-plan-ver",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/auditoria-plan-ver"),
    },

    //* *************** 6.1.4 Revisión anual por la Alta Dirección, resultados y alcance de la auditoría ************************** *//

    {
      path: "/forms/estandares/:id/planificacion-auditorias",
      name: "planificacion-auditorias",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/planificacion-auditorias"),
    },
  
    {
      path: "/forms/estandares/planificacion-auditorias-editar/:id",
      name: "planificacion-auditorias-editar",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/planificacion-auditorias-editar"),
    },
    {
      path: "/forms/estandares/planificacion-auditorias-ver/:id",
      name: "planificacion-auditorias-ver",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/planificacion-auditorias-ver"),
    },

  //* *************** 6.1.3 Revisión anual por la Alta Dirección, resultados y alcance de la auditoría ************************** *//

  {
    path: "/forms/estandares/:id/revision-anual",
    name: "revision-anual",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/revision-anual"),
  },

  {
    path: "/forms/estandares/revision-anual-editar/:id",
    name: "revision-anual-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/revision-anual-editar"),
  },
  {
    path: "/forms/estandares/:companyId/revision-direccion",
    name: "revision-direccion-nueva",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/revision-anual-editar"),
  },
  {
    path: "/forms/estandares/:companyId/revision-direccion/:review",
    name: "revision-direccion-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/revision-anual-editar"),
  },

  /*     {
      path: '/forms/estandares/:employee_id/restricciones-colaboraciones-seguimientos/:id',
      name: 'restricciones-colaboraciones-seguimientos',
      meta: {
        authRequired: true,
      },
      component: () => import('../views/pages/forms/restricciones-colaboraciones-seguimientos')
    }, */
  {
    path: "/forms/estandares/mantenimiento-periodico-editar/:id",
    name: "mantenimiento-periodico-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/mantenimiento-periodico-editar"),
  },
  {
    path: "/forms/estandares/:id/administracion-equipos",
    name: "administracion-equipos",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/administracion-equipos"),
  },
  {
    path: "/forms/estandares/administracion-equipos-editar/:id",
    name: "administracion-equipos-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/administracion-equipos-editar"),
  },

  {
    path: "/forms/estandares/:id/proteccion-personal",
    name: "proteccion-personal",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/proteccion-personal"),
  },
  {
    path: "/forms/estandares/proteccion-personal-editar/:id",
    name: "proteccion-personal-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/proteccion-personal-editar"),
  },
/**4.2.6 */
  {
    path: "/forms/estandares/:id/entrega-elementos",
    name: "entrega-elementos",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/entrega-elementos"),
  },
  {
    path: "/forms/estandares/entrega-elementos-editar/:id",
    name: "entrega-elementos-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/entrega-elementos-editar"),
  },
  {
    path: "/forms/estandares/:companyId/entrega-epp",
    name: "entrega-epp-nueva",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/entrega-elementos-editar"),
  },
  {
    path: "/forms/estandares/:companyId/entrega-epp/:delivery",
    name: "entrega-epp-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/entrega-elementos-editar"),
  },

  
  //* *************** 7.1.1 Acciones correctivas y/o preventivas  ************************** *//

  {
    path: "/forms/estandares/:id/acciones-correctivas-preventivas",
    name: "acciones-correctivas-preventivas",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/acciones-correctivas-preventivas"),
  },

  {
    path: "/forms/estandares/acciones-correctivas-preventivas-editar/:id",
    name: "acciones-correctivas-preventivas-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/acciones-correctivas-preventivas-editar"),
  },
  {
    path: "/forms/estandares/acciones-correctivas-preventivas-ver/:id",
    name: "acciones-correctivas-preventivas-ver",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/acciones-correctivas-preventivas-ver"),
  },

  {
    path: "/forms/estandares/:id/acciones-promocion-prevencion",
    name: "acciones-promocion-prevencion",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/acciones-promocion-prevencion"),
  },

  //* *************** 7.1.2 Toma de Medidas Correctivas, Preventivas y de Mejora  ************************** *//

  {
    path: "/forms/estandares/:id/medidas-correctivas-mejora",
    name: "medidas-correctivas-mejora",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/medidas-correctivas-mejora"),
  },
  {
    path: "/forms/estandares/:companyId/acpm-procedimiento",
    name: "acpm-procedimiento-nuevo",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/acpm-procedimiento-editar"),
  },
  {
    path: "/forms/estandares/:companyId/acpm-procedimiento/:procedure",
    name: "acpm-procedimiento-editar",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/acpm-procedimiento-editar"),
  },
  {
    path: "/forms/estandares/:companyId/acpm-matriz",
    name: "acpm-matriz-nueva",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/acpm-matriz-editar"),
  },
  {
    path: "/forms/estandares/:companyId/acpm-matriz/:matrix",
    name: "acpm-matriz-editar",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/acpm-matriz-editar"),
  },

  //* *************** 7.1.3 Ejecución de ACPM de investigaciones  ************************** *//

  {
    path: "/forms/estandares/:id/ejecucion-acpm-investigaciones",
    name: "ejecucion-acpm-investigaciones",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/ejecucion-acpm-investigaciones"),
  },
  {
    path: "/forms/estandares/:companyId/acpm-inv-procedimiento",
    name: "acpm-inv-procedimiento-nuevo",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/acpm-investigacion-procedimiento-editar"),
  },
  {
    path: "/forms/estandares/:companyId/acpm-inv-procedimiento/:procedure",
    name: "acpm-inv-procedimiento-editar",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/acpm-investigacion-procedimiento-editar"),
  },
  {
    path: "/forms/estandares/:companyId/acpm-inv-matriz",
    name: "acpm-inv-matriz-nueva",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/acpm-investigacion-matriz-editar"),
  },
  {
    path: "/forms/estandares/:companyId/acpm-inv-matriz/:matrix",
    name: "acpm-inv-matriz-editar",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/acpm-investigacion-matriz-editar"),
  },

  //* *************** 7.1.4 Medidas y acciones correctivas de autoridades y ARL  ************************** *//

  {
    path: "/forms/estandares/:id/implementacion-medidas-autoridades",
    name: "implementacion-medidas-autoridades",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/implementacion-medidas-autoridades"),
  },
  {
    path: "/forms/estandares/:companyId/requerimiento-autoridad",
    name: "requerimiento-autoridad-nuevo",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/requerimiento-autoridad-editar"),
  },
  {
    path: "/forms/estandares/:companyId/requerimiento-autoridad/:record",
    name: "requerimiento-autoridad-editar",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/requerimiento-autoridad-editar"),
  },
  {
    path: "/forms/estandares/:companyId/requerimiento-matriz",
    name: "requerimiento-matriz-nueva",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/requerimiento-matriz-editar"),
  },
  {
    path: "/forms/estandares/:companyId/requerimiento-matriz/:matrix",
    name: "requerimiento-matriz-editar",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/requerimiento-matriz-editar"),
  },

  //* *************** 7.1.1 Promoción y Prevención (hub P&P)  ************************** *//

  {
    path: "/forms/estandares/:id/promocion-prevencion-hub",
    name: "promocion-prevencion-hub",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/promocion-prevencion-hub"),
  },
  {
    path: "/forms/estandares/:companyId/pp-programa",
    name: "pp-programa-nuevo",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/pp-programa-editar"),
  },
  {
    path: "/forms/estandares/:companyId/pp-programa/:program",
    name: "pp-programa-editar",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/pp-programa-editar"),
  },
  {
    path: "/forms/estandares/:companyId/pp-matriz",
    name: "pp-matriz-nueva",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/pp-matriz-editar"),
  },
  {
    path: "/forms/estandares/:companyId/pp-matriz/:matrix",
    name: "pp-matriz-editar",
    meta: { authRequired: true },
    component: () => import("../views/pages/forms/pp-matriz-editar"),
  },



  //* *************** 5.1.1 Plan de Prevención, preparación y respuesta ante emergencias  ************************** *//

  {
    path: "/forms/estandares/:id/prevencion-emergencias",
    name: "prevencion-emergencias",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/prevencion-emergencias"),
  },

  {
    path: "/forms/estandares/prevencion-emergencias-editar/:id",
    name: "prevencion-emergencias-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/prevencion-emergencias-editar"),
  },

  {
    path: "/forms/estandares/prevencion-emergencias-actas/:id",
    name: "prevencion-emergencias-actas",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/prevencion-emergencias-actas"),
  },

  {
    path: "/forms/estandares/prevencion-emergencias-actas-editar/:id",
    name: "prevencion-emergencias-actas-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/prevencion-emergencias-actas-editar"),
  },

  //* ***************5.1.2************************** *//
  {
    path: "/forms/estandares/brigada-prevencion-registro/:id",
    name: "brigada-prevencion-registro",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/brigada-prevencion-registro"),
  },

  //* ***************2.3.1 Evaluación e identificación de Prioridades ************************** *//

  {
    path: "/forms/estandares/:id/evaluacion-identificacion",
    name: "evaluacion-identificacion",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/evaluacion-identificacion"),
  },

  {
    path: "/forms/estandares/evaluacion-identificacion-editar/:id",
    name: "evaluacion-identificacion-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/evaluacion-identificacion-editar"),
  },


  //* *************** 1.1.4 Afiliación al Sistema General de Riesgos Laborales  ************************** *//

  {
    path: "/forms/estandares/:id/afiliacion-sistema-riesgos",
    name: "afiliacion-sistema-riesgos",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/afiliacion-sistema-riesgos"),
  },

  {
    path: "/forms/estandares/afiliacion-sistema-riesgos-editar/:id",
    name: "afiliacion-sistema-riesgos-editar",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/afiliacion-sistema-riesgos-editar"),
  },

  {
    path: "/forms/estandares/afiliacion-sistema-riesgos-ver/:id",
    name: "afiliacion-sistema-riesgos-ver",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/afiliacion-sistema-riesgos-ver"),
  },

  //* *************** 1.1.5 Pago de Pensión Trabajadores de Alto Riesgo   ************************** *//

  {
    path: "/forms/estandares/:id/pension-trabajadores-alto-riesgo",
    name: "pension-trabajadores-alto-riesgo",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/pension-trabajadores-alto-riesgo"),
  },

  {
    path: "/forms/estandares/pension-trabajadores-alto-riesgo-editar/:id",
    name: "pension-trabajadores-alto-riesgo",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/forms/pension-trabajadores-alto-riesgo-editar"),
  },

  //* ***************2.2.1************************** *//
  { //listo
    path: "/forms/estandares/objetivos-definidos/:id",
    name: "brigada-prevencion",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/objetivos-definidos"),
  },
  { //listo
    path: "/forms/estandares/objetivos-definidos-registro",
    name: "brigada-prevencion-registro",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/objetivos-definidos-registrar"),
  },
  { //
    path: "/forms/estandares/objetivos-definidos-editar/:id",
    name: "brigada-prevencion-registro",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/objetivos-definidos-editar"),
  },
  {
    path: "/forms/estandares/seguimiento-objetivos/:id",
    name: "seguimiento-objetivos",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/seguimiento-objetivos"),
  },
  {
    path: "/forms/estandares/seguimiento-objetivos-editar/:id",
    name: "seguimiento-objetivos-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/seguimiento-objetivos-editar"),
  },
  //* ***************1.1.2************************** *//
  {
    path: "/forms/estandares/responsabilidades-sgsst/:id",
    name: "responsabilidades-sgsst",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/responsabilidades-sgsst"),
  },
  {
    path: "/forms/estandares/responsabilidades-sgsst-editar/:id",
    name: "responsabilidades-sgsst-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/responsabilidades-sgsst-editar"),
  },

  //* ***************2.6.1************************** *//
  {
    path: "/forms/estandares/rendicion/:id",
    name: "rendicion",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/rendicion"),
  },
  {
    path: "/forms/estandares/rendicion-editar/:id",
    name: "rendicion-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/rendicion-editar"),
  },

  //* *************** 2.7.1 Matriz legal   ************************** *//

  {
    path: "/forms/estandares/:id/matriz-legal",
    name: "matriz-legal",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/matriz-legal"),
  },
  {
    path: "/forms/estandares/:id/matriz-legal-2",
    name: "matriz-legal-2",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/matriz-legal-2"),
  },
  {
    path: "/forms/estandares/:companyId/matriz-legal-revision",
    name: "matriz-legal-revision-nueva",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/matriz-legal-editar"),
  },
  {
    path: "/forms/estandares/:companyId/matriz-legal-revision/:review",
    name: "matriz-legal-revision-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/matriz-legal-editar"),
  },

  //* *************** 2.9.1 Identificación, Evaluación para adquisición de productos y servicios en el SG SST ************************** *//

  {
    path: "/forms/estandares/:id/identificacion-evaluacion-productos-servicios",
    name: "identificacion-evaluacion-productos-servicios",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/identificacion-evaluacion-productos-servicios"),
  },


  {
    path: "/forms/estandares/identificacion-evaluacion-productos-servicios-editar/:id",
    name: "identificacion-evaluacion-productos-servicios-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/identificacion-evaluacion-productos-servicios-editar"),
  },

  {
    path: "/forms/estandares/:id/crear-colaborador",
    name: "crear-colaborador",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/crear-colaborador"),
  },

  {
    path: "/forms/estandares/crear-colaborador-editar/:id",
    name: "crear-colaborador-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/crear-colaborador-editar"),
  },

  //* *************** 2.10.1 Evaluación y selección de proveedores  ************************** *//

  {
    path: "/forms/estandares/:id/evaluacion-seleccion-proveedores",
    name: "evaluacion-seleccion-proveedores",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/evaluacion-seleccion-proveedores"),
  },

  {
    path: "/forms/estandares/evaluacion-seleccion-proveedores-editar/:id",
    name: "evaluacion-seleccion-proveedores-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/evaluacion-seleccion-proveedores-editar"),
  },

  {
    path: "/forms/estandares/evaluacion-seleccion-proveedores-ver/:id",
    name: "evaluacion-seleccion-proveedores-ver",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/evaluacion-seleccion-proveedores-ver"),
  },



  {
    path: "/forms/estandares/evaluacion-seleccion-proveedores2.10.1-1/:id",
    name: "evaluacion-seleccion-proveedores2.10.1-1",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/evaluacion-seleccion-proveedores2.10.1-1"),
  },

  {
    path: "/forms/estandares/evaluacion-seleccion-proveedores2.10.1-1-editar/:id",
    name: "evaluacion-seleccion-proveedores2.10.1-1-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/evaluacion-seleccion-proveedores2.10.1-1-editar"),
  },

    //* *************** 2.11.1 Evaluación del impacto de cambios internos y externos en el SG SST  ************************** *//

    {
      path: "/forms/estandares/:id/evaluacion-impacto",
      name: "evaluacion-impacto",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/evaluacion-impacto"),
    },

    {
      path: "/forms/estandares/evaluacion-impacto-editar/:id",
      name: "evaluacion-impacto-editar",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/evaluacion-impacto-editar"),
    },

    {
      path: "/forms/estandares/evaluacion-impacto-ver/:id",
      name: "evaluacion-impacto-ver",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/evaluacion-impacto-ver"),
    },

    {
      path: "/forms/estandares/gestion-cambio/:id",
      name: "gestion-cambio",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/gestion-cambio"),
    },

    {
      path: "/forms/estandares/gestion-cambio-editar/:id",
      name: "gestion-cambio-editar",
      meta: {
        authRequired: true,
      },
      component: () => import("../views/pages/forms/gestion-cambio-editar"),
    },
  //* ***************2.8.1************************** *//
  {
    path: "/forms/estandares/:id/mecanismo-comunicacion",
    name: "mecanismo-comunicacion",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/mecanismo-comunicacion"),
  },
  {
    path: "/forms/estandares/:id/informe-autorreportes",
    name: "informe-autorreportes",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/informe-autorreportes"),
  },
  {
    path: "/forms/estandares/evidencia-comunicaciones-editar/:id",
    name: "evidencia-comunicacion-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/evidencia-comunicaciones-editar"),
  },
  {
    path: "/forms/estandares/reporte-condicion-editar/:id",
    name: "reporte-condicion-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/reporte-condicion-editar"),
  },
  {
    path: "/forms/estandares/reporte-condicion-salud-editar/:id",
    name: "reporte-condicion-salud-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/reporte-condicion-salud-editar "),
  },
/**3.2.3 */
  {
    path: '/forms/estandares/:id/grafica',
    name: 'grafica',
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/Grafica/Grafica.vue"),
  },

  //- -Configuracion ---- //
  {
    path: "/forms/configuracion",
    name: "configuracion",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/Configuracion/configuracion"),
  },
  {
    path: "/forms/configuracion/puntuacion",
    name: "puntuation",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/Configuracion/puntuation"),
  },
  {
    path: "/forms/configuracion/puntuacion-editar/:id",
    name: "puntuation-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/Configuracion/puntuation-editar"),
  },
 //- -manual de usario ---- //
 {
  path: "/forms/manualUsuario",
  name: "manualUsuario",
  meta: {
    authRequired: true,
  },
  component: () => import("../views/pages/forms/ManualUsuario/ManualUsuario"),
},
  //- -PHVA ---- //
  {
    path: "/forms/phva",
    name: "phva",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/phva/phva"),
  },
  {
    path: "/forms/configuracion/puntuacion",
    name: "puntuation",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/Configuracion/puntuation"),
  },
  {
    path: "/forms/configuracion/puntuacion-editar/:id",
    name: "puntuation-editar",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/Configuracion/puntuation-editar"),
  },

  //- -reporte ---- //
  {
    path: "/forms/reporte",
    name: "reporte",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/reporte/reporte"),
  },

  {
    path: "/forms/caracterizacion-accidentalidad",
    name: "caracterizacion-accidentalidad",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/forms/caracterizacion-accidentalidad"),
  },

  // Cualquier otra URL: 404 dentro del shell (debe ir al final)
  {
    path: "*",
    name: "not-found",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/error/not-found"),
  },
];
